import { axiosPrivate } from 'shared/api';
import { BaseService } from 'shared/services/BaseService';
import { IExamHisotryLines } from '../types';

class ExamHistoryLineService extends BaseService<IExamHisotryLines> {
  constructor() {
    super('exam-history-lines');
  }

  importFromFile = async (importFile: File, attachmentName = 'import_file') => {
    const res = await axiosPrivate.postForm(`${this.modulePrefix}/import-from-file/`, {
      [attachmentName]: importFile
    });
    return res.data;
  };
}

export const examHistoryLineService = new ExamHistoryLineService();
